import React from 'react';
import { Div } from './Notifications.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
//import Button from 'src/common/components/button/Button';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import {
    ItemsNotAllowedText,
    ExclusionItemsNotAllowedDiv,
    ItemsSubText,
} from './Notifications.styled';
import { useTranslation } from 'react-i18next';

const AddedMoreThanTenItems = ({
    onClose,
    title,
    allowedCount,
    showProductTemplateMessage = false,
    onCancel = () => {},
    opacity = 10,
    zIndex,
    background,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <Popup
                title={
                    title ? title : t('equity.surgery.notifications.moreThan10')
                }
                onClose={onClose}
                width={showProductTemplateMessage ? '' : '300px'}
                webWidth={showProductTemplateMessage ? '' : '352px'}
                webHeight={showProductTemplateMessage ? '' : '78px'}
                fontSize={'17px'}
                opacity={opacity}
                zIndex={zIndex}
                impersonationBackground={background}
                id={'equity-surgery-addedMoreThanTenItems-popup'}
            >
                {showProductTemplateMessage ? (
                    <ExclusionItemsNotAllowedDiv
                        mbHeight={'150px'}
                        height={'132px'}
                        width={'100%'}
                        hideScroll={true}
                    >
                        <ItemsNotAllowedText margin={'0px'}>
                            {`${allowedCount} ${t(
                                'equity.surgery.notifications.itemsCart'
                            )} `}
                        </ItemsNotAllowedText>
                        <ItemsSubText height={'40px'} webHeight={'unset'}>
                            {t('equity.surgery.notifications.moreThan10')}
                        </ItemsSubText>
                    </ExclusionItemsNotAllowedDiv>
                ) : null}

                {showProductTemplateMessage ? (
                    <Div showCancel={true} justifyContent={'flex-end'}>
                        <Button
                            id={'equity-surgery-addedmorethantenitems-cancel'}
                            variant={ButtonStyles?.popUpSecondary}
                           // popUpSecondary={true}
                            show={true}
                            width={'150px'}
                            height={'36px'}
                            secondary={true}
                            margin={'13px 3px 0px 0px'}
                            fontSize={'13px'}
                            clicked={onCancel}
                        >
                            {t('equity.equityFooter.cancelButton')}
                        </Button>
                        <Button
                         id={'equity-surgery-addedmorethantenitems-okbutton'}
                           
                            show={true}
                            width={'150px'}
                            height={'36px'}
                            variant={ButtonStyles?.primary}
                           // primary={true}
                            borderRadius={'19px'}
                            margin={'13px 5px 0px 2px'}
                            fontSize={'13px'}
                            fontFamily={'AvenirNextWorld Demi'}
                            clicked={onClose}
                        >
                            {t('equity.surgery.notifications.ok')}
                        </Button>
                    </Div>
                ) : (
                    <Div>
                        <Button
                         id={'equity-surgery-addedmorethantenitems-notifications'}
                            show={true}
                            width={'150px'}
                            height={'38px'}
                            variant={ButtonStyles?.primary}
                           // primary={true}
                            margin={'5px 0px 5px 5px'}
                            fontSize={'13px'}
                            clicked={onClose}
                        >
                            {t('equity.surgery.notifications.ok')}
                        </Button>
                    </Div>
                )}
            </Popup>
        </>
    );
};

export default AddedMoreThanTenItems;
